import { render, staticRenderFns } from "./basic-form-elements.vue?vue&type=template&id=08490b8e&"
import script from "./basic-form-elements.vue?vue&type=script&lang=js&"
export * from "./basic-form-elements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports